var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_477_1027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.29409 16.1766V8.82364H11.7059V16.1766M2.88232 6.61776L9.49997 1.4707L16.1176 6.61776V14.706C16.1176 15.096 15.9627 15.4701 15.6869 15.7459C15.4111 16.0216 15.0371 16.1766 14.647 16.1766H4.35291C3.96289 16.1766 3.58884 16.0216 3.31305 15.7459C3.03726 15.4701 2.88232 15.096 2.88232 14.706V6.61776Z",
    stroke: "currentColor",
    strokeWidth: 1.83824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_477_1027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6471,
    height: 17.6471,
    fill: "white",
    transform: "translate(0.676453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBold);
export default __webpack_public_path__ + "static/media/HomeBold.33cde2d2cc828e990578d4055bfc83ae.svg";
export { ForwardRef as ReactComponent };